import React, { useEffect, useState } from "react";
import { Form, Input, Button, Link } from "@heroui/react";
import { InputOtp } from "@heroui/react";
import axios from 'axios'
import toast from "react-hot-toast";
import { SERVER_URL } from "../../../Config";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const [submitted, setSubmitted] = React.useState(null);
  const [errors, setErrors] = React.useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = React.useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [email, setAppID] = useState("");
  const [mnemonics, setMnemonics] = useState("");

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });
    data.secret_pin = value;
    setIsLoading(true);
    setErrors({});
    setIsLoading(true)
    setIsSubmitting(true)
    try {
      await axios.post(`${SERVER_URL}/api/LoginUser`, data).then((res) => {
        if (res.data.status == true) {
          toast.success('Welcome User, You are in !')
          sessionStorage.setItem('_token', res.data.token);
          setTimeout(() => {
            navigate('/Dashboard', { state: res.data.User })
          }, 1000);
        } else {
          toast.error(res.data.message)
          setIsLoading(false)
          setIsSubmitting(false);
          return false
        }
      })
    } catch (err) {
      toast.error('Registration Failed due to Internal server Error')
      setIsLoading(false)
      setIsSubmitting(false);
      return false
    }
  };

  const handleForgotPasswordClick = () => {
    setShowForgotPasswordModal(true);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (step === 1) {
      if (!email || !mnemonics) {
        toast.error("Please fill in both fields");
        return;
      }

      try {
        const response = await axios.post(`${SERVER_URL}/api/forgetpassword`, { email, mnemonics });

        if (response.data.success) {
          toast.success("OTP sent to your email!");
          setStep(2); // Move to step 2 (OTP input)
        } else {
          toast.error(response.data.message || "Invalid email or mnemonics!");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
      }
    } else if (step === 2) {
      if (!otp || !newPassword || !confirmPassword) {
        toast.error("Please enter OTP, new password, and confirm password");
        return;
      }

      // **Check if passwords match**
      if (newPassword !== confirmPassword) {
        toast.error("Passwords do not match!");
        return;
      }

      try {
        const response = await axios.post(`${SERVER_URL}/api/verifyOtp`, { email, otp, newPassword });

        if (response.data.success) {
          toast.success("Password reset successful!");
          setShowForgotPasswordModal(false);
        } else {
          toast.error(response.data.message || "Invalid OTP!");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
      }
    }
  };

  return (
    <div className=" bg-[#060606] h-screen overflow-hidden overflow-y-auto relative text-white ">
      <div
        className=" h-screen opacity-15 -translate-y-36 "
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)",
        }}
      ></div>
      <div className="absolute top-[30%] left-0 right-0">
        <div
          className="max-w-3xl w-full mx-auto h-96 opacity-15 -translate-y-10 "
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(255, 242, 194, 0.44) 0%, rgba(0, 0, 0, 0) 100%)",
          }}
        ></div>
        <div className="flex justify-center absolute top-0 left-0 right-0 w-full ">
          <img src="../assets/other/dashboard1.svg" className="" />
          <img
            src="../assets/other/dashboard1.svg"
            className=" scale-x-[-1] "
          />
        </div>
      </div>

      <div className=" absolute top-0 left-0 right-0 h-screen flex justify-center items-center ">
        <div className=" w-[95%] z-30 mx-auto max-w-md bg-gradient-to-b from-[#0B0F1060] to-[#241D1460] p-5 rounded-3xl border border-[#2F2F2F]  font-poppins dark text-foreground">

          <div className="flex items-center justify-center gap-2 mb-6 ">
            <img className="w-20 h-20" src="../assets/Logo/logo.svg" alt="Stabilix Logo" />
            <p className="font-bold text-2xl font-Artemus">STABILIX</p>
          </div>

          <Form
            className="w-full flex flex-col justify-center items-center space-y-4"
            validationBehavior="native"
            validationErrors={errors}
            onReset={() => setSubmitted(null)}
            onSubmit={onSubmit}
          >
          
            <div className="flex flex-col gap-4 w-[85%] mx-auto ">
              <Input
                isRequired
                errorMessage={({ validationDetails }) => {
                  if (validationDetails.valueMissing) {
                    return "Please Enter AppID";
                  }
                }}
                label="AppID"
                labelPlacement="outside"
                name="AppID"
                placeholder="AppID"
                type="text"
              />

              <div className="flex flex-col justify-start items-start w-full gap-2">
                <label className="text-sm font-medium text-white">
                  Secret Pin <span className="text-danger">*</span>
                </label>
                <InputOtp
                  isRequired
                  errorMessage={({ validationDetails }) => {
                    if (validationDetails.valueMissing) {
                      return "Please Enter Secret Pin";
                    }
                  }}
                  length={6}
                  value={value}
                  onValueChange={setValue}
                  type="password"
                  variant="bordered"
                  className="w-full"
                />
              </div>

              <div>
                {showForgotPasswordModal && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm z-50">
                    <div className="relative bg-[#1A1B18]/90 text-white p-6 rounded-2xl shadow-xl w-96 border border-[#2F2F2F] backdrop-blur-md z-50">
                      <h2 className="text-2xl font-semibold text-center mb-4 text-[#F6FFE9]">
                        Reset Password
                      </h2>

                      <div className="space-y-4">
                        {step === 1 ? (
                          <>
                            <input
                              type="text"
                              placeholder="Enter your AppID"
                              value={email}
                              onChange={(e) => setAppID(e.target.value)}
                              className="w-full px-4 py-2 bg-[#2F2F2F] border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F6FFE9] placeholder-gray-400"
                            />

                            <input
                              type="text"
                              placeholder="Enter your mnemonics"
                              value={mnemonics}
                              onChange={(e) => setMnemonics(e.target.value)}
                              className="w-full px-4 py-2 bg-[#2F2F2F] border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F6FFE9] placeholder-gray-400"
                            />
                          </>
                        ) : (
                          <>
                            <input
                              type="text"
                              placeholder="Enter OTP"
                              value={otp}
                              onChange={(e) => setOtp(e.target.value)}
                              className="w-full px-4 py-2 bg-[#2F2F2F] border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F6FFE9] placeholder-gray-400"
                            />

                            <input
                              type="password"
                              placeholder="Enter new password"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              className="w-full px-4 py-2 bg-[#2F2F2F] border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F6FFE9] placeholder-gray-400"
                            />

                            <input
                              type="password"
                              placeholder="Confirm new password"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              className="w-full px-4 py-2 bg-[#2F2F2F] border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F6FFE9] placeholder-gray-400"
                            />
                          </>
                        )}

                        <div className="flex gap-3 mt-4">
                          <button
                            onClick={handleResetPassword}
                            className="w-full bg-gradient-to-r from-[#F6FFE9] to-[#94998C] text-black px-4 py-2 rounded-md font-medium hover:from-[#D4E157] hover:to-[#A0A08C] transition"
                          >
                            {step === 1 ? "Submit" : "Reset Password"}
                          </button>

                          <button
                            onClick={() => setShowForgotPasswordModal(false)}
                            className="w-full bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-500 transition"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


              </div>

              <Button color="danger" type="submit" isLoading={isLoading} className='w-full bg-gradient-to-br from-[#F6FFE9] to-[#94998C] p-0.5 rounded-full '>
                <div className='w-full font-Artemus bg-gradient-to-r from-[#1A1B18] to-[#856E4F] rounded-full p-2'>
                  <p className='font-Artemus font-medium text-center text-white '>Login to Platform</p>
                </div>
              </Button>

              <Button
                showAnchorIcon
                as={Link}
                color="foreground"
                className="text-white"
                href="/Register"
                variant="solid"
              >
                Click here for Register
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
